export enum ETabs {
  WORKSHIFT,
  REVIEW,
  CLIENTS,
  VISITORS,
  HOSTS_OCCUPATION,
  PLAY_AND_APLLICATIONS,
  SALES,
  TRANSFERS,
  BONUS,
}
